export default __webpack_public_path__ + "static/media/twitter.88275f24.svg";